import { Types } from './types'

const initialState = {
    dataFeatureTech :  {
        rows: [],
        paging: {}
    },
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_FEATURE_TECH:
            return {
                ...newState,
                dataFeatureTech: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
